import React from 'react';

interface NetbankingPaymentsProps extends React.SVGProps<SVGSVGElement> {}

const NetbankingPayments: React.FC<NetbankingPaymentsProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.376 3.44891C16.9765 3.1572 16.4947 3 16 3C15.5053 3 15.0235 3.1572 14.624 3.44891L4.72933 10.6689C3.42533 11.6196 4.09867 13.6822 5.71067 13.6822H6V21.4156C5.39792 21.7228 4.89249 22.1905 4.53955 22.767C4.1866 23.3435 3.99987 24.0063 4 24.6822V26.6822C4 27.2329 4.448 27.6822 5 27.6822H27C27.2652 27.6822 27.5196 27.5769 27.7071 27.3893C27.8946 27.2018 28 26.9475 28 26.6822V24.6822C28.0001 24.0063 27.8134 23.3435 27.4605 22.767C27.1075 22.1905 26.6021 21.7228 26 21.4156V13.6822H26.2893C27.9027 13.6822 28.5733 11.6196 27.2707 10.6689L17.376 3.44891ZM15.8027 5.06357C15.8598 5.02186 15.9286 4.99937 15.9993 4.99937C16.07 4.99937 16.1389 5.02186 16.196 5.06357L25.2667 11.6822H6.73333L15.8027 5.06357ZM24 13.6822V21.0156H21.3333V13.6822H24ZM19.3333 13.6822V21.0156H17V13.6822H19.3333ZM15 13.6822V17.3489V21.0156H12.6667V13.6822H15ZM7.66667 23.0156H24.3333C25.2533 23.0156 26 23.7622 26 24.6822V25.6822H6V24.6822C6 23.7622 6.74667 23.0156 7.66667 23.0156ZM8 21.0156V13.6822H10.6667V21.0156H8Z"
      fill="black"
    />
  </svg>
);

export default React.memo(NetbankingPayments);
